(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RIFDataVault", [], factory);
	else if(typeof exports === 'object')
		exports["RIFDataVault"] = factory();
	else
		root["RIFDataVault"] = factory();
})(this, function() {
return 